<template>
  <div>
    <slot
      name="element"
      :onClick="fetchTrainingRegistrationInvoice"
      :loading="loading"
    />

    <v-snackbar
      :value="snackbarError"
      @input="resetSnackbar"
      timeout="3000"
      color="error"
    >
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="resetSnackbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { doQuery } from "@/app/core-module/util/graphqlHelper";
import { bulkDownloadTrainingRegistrationInvoices } from "@/app/invoices-module/helpers/invoiceHelper";

export default {
  name: "InvoiceDownloadButton",
  props: {
    trainingRegistration: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      snackbarError: false,
      snackbarErrorMessage: null,
    };
  },
  methods: {
    resetSnackbar() {
      this.snackbarError = false;
      this.snackbarErrorMessage = null;
    },
    async fetchTrainingRegistrationInvoice() {
      if (this.loading) return;
      this.loading = true;

      const trainingRegistrationInvoices = await doQuery({
        query: require("../api/query/getTrainingRegistrationInvoice.gql"),
        variables: { id: this.trainingRegistration.invoice._id },
      }).then(response => {
        if (response?.data?.getTrainingRegistrationInvoice) {
          return [response.data.getTrainingRegistrationInvoice];
        }
      });

      const subscriberInfo = await doQuery({
        query: require("../../user-module/api/query/getSubscriberProfile.gql"),
      }).then(response => {
        if (response?.data?.getSubscriberProfile) {
          return response.data.getSubscriberProfile;
        }
      });

      if (trainingRegistrationInvoices && subscriberInfo) {
        await bulkDownloadTrainingRegistrationInvoices({
          trainingRegistrationInvoices,
          subscriberInfo,
        });

        this.loading = false;
      } else {
        this.snackbarError = true;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
